import {mark, types as metrics} from '@servicenow/ui-metrics';
import {memoize, toString} from '@servicenow/ui-internal';
import {filterPropertyDefinitions, toAttributeName, getHostVariables} from '../utils';
import reflectQueue from '../utils/reflectQueue'; // TODO: why is this required?
import {schedule, types} from '../scheduler';
import {PROPERTY_DEFS} from '../symbols';

const {REFLECT_PROPERTIES} = types;

const isAria = memoize(name => name.indexOf('aria') === 0, {profileName: 'isAria'});

const shouldRemoveAttribute = (name, value) => {
	if (isAria(name)) return !toString(value);

	return !value;
};

const getAttributeValue = (name, value) => {
	if (isAria(name)) return toString(value);

	return value === true ? '' : value;
};

const filterRelectedProperties = memoize(
	host => {
		const hostVariables = getHostVariables(host);
		const properties = filterPropertyDefinitions(hostVariables[PROPERTY_DEFS], d => d.reflect);
		const keys = Object.keys(properties);
		return {
			properties,
			keys
		};
	},
	{createCacheKey: host => host.tagName, profileName: 'filterRelectedProperties'}
);
const filterUnstableParseProperties = memoize(
	host => {
		const hostVariables = getHostVariables(host);
		return filterPropertyDefinitions(hostVariables[PROPERTY_DEFS], d => d.unstableParse);
	},
	{createCacheKey: host => host.tagName, profileName: 'filterUnstableParseProperties'}
);
const resolveValue = (propName, propDef, state) => {
	if (propDef.computed) {
		const computedValue = propDef.computed(state);
		if (computedValue !== undefined) return computedValue;
	}
	const stateValue = state.properties[propName];
	if (stateValue !== undefined) return stateValue;

	return propDef.default || null;
};

export function reflectProperty(propName, propDef, state, host, usingUnstableParse) {
	const value = resolveValue(propName, propDef, state);
	const attributeName = toAttributeName(propName);
	const attributeValue = getAttributeValue(attributeName, value);

	if (shouldRemoveAttribute(attributeName, value) && host.hasAttribute(attributeName)) {
		reflectQueue.push(attributeName);

		host.removeAttribute(attributeName);
	} else {
		if (
			host.getAttribute(attributeName) !== attributeValue &&
			((value !== null && value !== undefined && value !== false) ||
				(isAria(attributeName) && attributeValue))
		) {
			reflectQueue.push(attributeName);

			if (usingUnstableParse[propName])
				host.setAttribute(attributeName, JSON.stringify(attributeValue), true);
			else host.setAttribute(attributeName, attributeValue, true);
		}
	}
}

export default function reflectProperties(state, host, interactionId) {
	const {properties: reflected, keys} = filterRelectedProperties(host);
	const usingUnstableParse = filterUnstableParseProperties(host);

	schedule({
		fn() {
			mark(host, interactionId, metrics.PROPERTY_REFLECTION, {properties: keys});
			for (const propName in reflected)
				reflectProperty(propName, reflected[propName], state, host, usingUnstableParse);
		},
		type: REFLECT_PROPERTIES,
		meta: {el: host, interactionId}
	});

	return state;
}
